import React, { useState, useEffect } from 'react';
import logo from './logoo.jpg';
import pic1 from './gallery/1.jpg';
import pic2 from './gallery/2.jpg';
import pic3 from './gallery/3.jpg';
import pic4 from './gallery/4.jpg';
import pic5 from './gallery/5.jpg';
import pic6 from './gallery/6.jpg';
import pic7 from './gallery/7.jpg';
import pic8 from './gallery/8.jpg';
import pic9 from './gallery/9.jpg';
import pic10 from './gallery/10.jpg';
import pic11 from './gallery/11.jpg';
import pic12 from './gallery/12.jpg';

import { Pagination } from 'swiper/modules';
import 'swiper/css/pagination';

import { Navigation } from 'swiper/modules';
import 'swiper/css/navigation';

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import "yet-another-react-lightbox/plugins/thumbnails.css";

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaInstagram, FaLinkedinIn, FaTiktok, FaCalendarAlt, FaClock } from 'react-icons/fa';

import ReservationModal from './components/ReservationModal';
import SectionDivider from './components/SectionDivider';



function App() {
  const [showFullMenu, setShowFullMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('');

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [reservationOpen, setReservationOpen] = useState(false);

  const galleryImages = [
    { src: pic1, alt: "Gallery 1" },
    { src: pic2, alt: "Gallery 2" },
    { src: pic3, alt: "Gallery 3" },
    { src: pic4, alt: "Gallery 4" },
    { src: pic5, alt: "Gallery 5" },
    { src: pic6, alt: "Gallery 6" },
    { src: pic7, alt: "Gallery 7" },
    { src: pic8, alt: "Gallery 8" },
    { src: pic9, alt: "Gallery 9" },
    { src: pic10, alt: "Gallery 10" },
    { src: pic11, alt: "Gallery 11" },
    { src: pic12, alt: "Gallery 12" }
  ];


  const vegetarianDishes = [
    { name: "Shiro Wot", description: "Smooth chickpea stew simmered with spices", price: "€16" },
    { name: "Misir Wot", description: "Spicy lentil stew simmered with berbere spices", price: "€16" },
    { name: "Fosolia", description: "Green beans and carrots sautéed with onions and spices", price: "€16" },
    { name: "Gomen", description: "Kale cooked with onions, garlic, and spices", price: "€16" },
    { name: "Tekele Gomen", description: "Cabbage cooked with potatoes, carrots, and spices", price: "€16" },
    { name: "Alicha Kik", description: "Mild split pea stew cooked with turmeric and spices", price: "€16" },
    { name: "Beyaynetu", description: "Assorted vegetarian dishes served on injera", price: "€20" },
  ];

  const mainDishes = [
    { name: "Ye Bege Key Wot / Alecha", description: "Spicy lamb stew or mild lamb stew with turmeric", price: "€17" },
    { name: "Key Wot Zegni / Alecha", description: "Spicy beef stew or mild beef stew with turmeric", price: "€17" },
    { name: "Ye Bege Kekele", description: "Lamb grilled with awaze sauce, onion, and paprika", price: "€17" },
    { name: "Gomen Besega", description: "Beef cooked with onions, simmered with kale", price: "€17" },
    { name: "Kitfo", description: "Minced raw beef seasoned with mitmita and niter kibbeh", price: "€22" },
    { name: "Gorde Gorede", description: "Lightly cooked minced beef seasoned with mitmita", price: "€22" },
    { name: "Normal Tibs", description: "Sautéed lamb, beef, or chicken with spices", price: "€19" },
    { name: "Shekla Tibs (Special)", description: "Stir-fried lamb, beef, or chicken served sizzling", price: "€20" },
    { name: "Doro Wot", description: "Spicy chicken stew with egg", price: "€19" },
    { name: "Bozena Shiro", description: "Chickpea stew with beef pieces", price: "€17" },
    { name: "Sega Mhaberawi", description: "Combination meat plate", price: "€20" },
    { name: "Aregash Special", description: "Chef’s special selection", price: "€24" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);

      const sections = ['menu', 'about', 'gallery', 'contact'];
      const offset = window.innerHeight * 0.3; // adjust to 30% from top

      for (let id of sections) {
        const element = document.getElementById(id);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= offset && rect.bottom >= offset) {
            setActiveSection(id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  return (
    <div className="min-h-screen bg-cream font-sans scroll-smooth">
      {/* Flag accent stripe */}
      <div className="flex h-1.5 w-full">
        <div className="flex-1 bg-flag-green" />
        <div className="flex-1 bg-flag-yellow" />
        <div className="flex-1 bg-flag-red" />
      </div>

      {/* Header/Navigation */}
      <header className={`sticky top-0 z-50 p-4 transition-all duration-500 ease-in-out ${scrolled ? 'bg-cream/90 backdrop-blur-md shadow-sm' : 'bg-cream'} text-coffee`}>
        <div className="max-w-6xl mx-auto flex flex-row items-center justify-between">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center gap-3"
          >
            <img src={logo} alt="Aregash Logo" className="w-14 h-14 rounded-full object-cover ring-2 ring-gold/60" />
            <h1 className="font-display text-2xl md:text-3xl font-semibold tracking-wide">Aregash Ethiopian Restaurant</h1>
          </button>


          <nav>
            <ul className="flex gap-6 font-medium">
              <li><a href="#menu" className={`transition ${activeSection === 'menu' ? 'text-terracotta font-bold' : 'hover:text-terracotta'}`}>Menu</a></li>
              <li><a href="#about" className={`transition ${activeSection === 'about' ? 'text-terracotta font-bold' : 'hover:text-terracotta'}`}>About</a></li>
              <li><a href="#contact" className={`transition ${activeSection === 'contact' ? 'text-terracotta font-bold' : 'hover:text-terracotta'}`}>Contact</a></li>
            </ul>
          </nav>
        </div>
      </header>


      {/* Hero Section */}
      <div className="relative h-[560px] bg-[url('https://www.willflyforfood.net/wp-content/uploads/2021/09/ethiopian-food-yetsom-beyaynetu.jpg.webp')] bg-cover bg-center">
        <div className="absolute inset-0 bg-gradient-to-b from-coffee/80 via-coffee/55 to-coffee/80 flex items-center justify-center">
          <div className="text-center text-cream p-4 max-w-2xl">
            <p className="uppercase tracking-[0.3em] text-gold-light text-sm mb-4">Den Haag · Since 2024</p>
            <h2 className="font-display text-5xl md:text-6xl font-semibold mb-4 leading-tight">
              Authentic Ethiopian Cuisine
            </h2>
            <div className="w-20 h-[2px] bg-gold mx-auto mb-6" />
            <p className="text-lg md:text-xl mb-8 text-cream/90">
              Experience the rich flavors and warm hospitality of Ethiopia, right here in Den Haag
            </p>
            <button
              onClick={() => setReservationOpen(true)}
              className="bg-terracotta text-cream px-8 py-3 rounded-full font-medium hover:bg-terracotta-dark hover:-translate-y-0.5 shadow-lg transition"
            >
              Reserve a Table
            </button>
          </div>
        </div>
      </div>

      <ReservationModal open={reservationOpen} onClose={() => setReservationOpen(false)} />


      {/* Menu Section */}
      <section id="menu" className="bg-cream py-20 px-6 scroll-mt-24">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-display text-4xl font-semibold text-center text-coffee mb-2">Our Menu</h2>
          <SectionDivider className="-mt-2" />

          {/* Vegetarian Dishes */}
          <div className="mb-16">
            <h3 className="font-display text-3xl font-medium text-terracotta mb-8 text-center">Vegetarian Dishes</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {(showFullMenu ? vegetarianDishes : vegetarianDishes.slice(0, 3)).map((dish, index) => (
                <div key={index} className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-lg hover:-translate-y-1 transition border-t-4 border-gold">
                  <h4 className="font-display text-xl font-semibold mb-2 text-coffee">{dish.name}</h4>
                  <p className="text-gray-600 text-sm">{dish.description}</p>
                  <p className="mt-4 text-terracotta font-semibold">{dish.price}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Main Dishes */}
          <div>
            <h3 className="font-display text-3xl font-medium text-terracotta mb-8 text-center">Main Dishes</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {(showFullMenu ? mainDishes : mainDishes.slice(0, 3)).map((dish, index) => (
                <div key={index} className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-lg hover:-translate-y-1 transition border-t-4 border-gold">
                  <h4 className="font-display text-xl font-semibold mb-2 text-coffee">{dish.name}</h4>
                  <p className="text-gray-600 text-sm">{dish.description}</p>
                  <p className="mt-4 text-terracotta font-semibold">{dish.price}</p>
                </div>
              ))}
            </div>
          </div>

          {/* See More / See Less Button */}
          <div className="text-center mt-16">
            <button
              onClick={() => setShowFullMenu(!showFullMenu)}
              className="bg-coffee hover:bg-coffee-light text-cream font-medium px-8 py-3 rounded-full transition"
            >
              {showFullMenu ? "Show Less" : "Show Full Menu"}
            </button>
          </div>
        </div>
      </section>


      {/* About Section */}
      <section id="about" className="relative bg-coffee text-cream py-24 px-6 overflow-hidden scroll-mt-24">
        <svg
          className="absolute -right-16 -top-16 w-80 h-80 text-gold/10"
          viewBox="0 0 100 100"
          fill="none"
        >
          <path d="M50 0V100M0 50H100" stroke="currentColor" strokeWidth="6" />
        </svg>
        <div className="relative max-w-4xl mx-auto text-center">
          <h2 className="font-display text-4xl font-semibold mb-2">Our Story</h2>
          <SectionDivider />
          <p className="text-lg text-cream/85 leading-relaxed">
            Bringing the authentic tastes of Ethiopia to Den Haag since 2024. Our recipes have been passed down through generations,
            carefully preserving the rich flavors and traditions. At Aregash Ethiopian Restaurant, we take pride in crafting every dish
            with fresh, high-quality ingredients, and sharing the warm spirit of Ethiopian hospitality with every guest.
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="py-20 px-6 bg-cream scroll-mt-24">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-display text-4xl font-semibold text-center text-coffee mb-2">Gallery</h2>
          <SectionDivider className="-mt-2 mb-6" />

          <Swiper
            modules={[Navigation, Pagination]}
            navigation
            pagination={{ clickable: true }}
            spaceBetween={20}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            loop={true}
            autoplay={{ delay: 3000 }}
          >
            {galleryImages.map((image, index) => (
              <SwiperSlide key={index}>
                <img
                  src={image.src}
                  alt={image.alt}
                  className="rounded-2xl shadow-md w-full h-64 object-cover cursor-pointer ring-1 ring-transparent hover:ring-gold transition"
                  onClick={() => { setPhotoIndex(index); setLightboxOpen(true); }}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          {lightboxOpen && (
            <Lightbox
              mainSrc={galleryImages[photoIndex].src}
              nextSrc={galleryImages[(photoIndex + 1) % galleryImages.length].src}
              prevSrc={galleryImages[(photoIndex + galleryImages.length - 1) % galleryImages.length].src}
              onCloseRequest={() => setLightboxOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + galleryImages.length - 1) % galleryImages.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % galleryImages.length)
              }
            />
          )}
        </div>
      </section>

      <section id="contact" className="scroll-mt-24">
        <footer className="bg-coffee text-cream/80 py-20 px-6">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
            {/* Contact Info */}
            <div>
              <h3 className="font-display text-2xl font-semibold mb-6 text-cream">Contact Us</h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-center text-cream">
                  <FaMapMarkerAlt className="text-gold mr-3" />
                  Amsterdamse Veerkade 8, 2512 AJ Den Haag, The Netherlands
                </li>
                <li className="flex items-center text-cream">
                  <FaPhoneAlt className="text-gold mr-3" />
                  +31 646741098
                </li>
                <li className="flex items-center text-cream">
                  <FaEnvelope className="text-gold mr-3" />
                  habesha@aregash.nl
                </li>
                <li className="flex items-center text-cream">
                  <FaClock className="text-gold mr-3" />
                  16:00 – 23:00, Wednesday – Monday (Closed Tuesdays)
                </li>
              </ul>
              <div className="flex gap-4 mt-6">
                <a href="https://www.instagram.com/aregash_ethiopisch_restaurant?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer">
                  <FaInstagram className="text-cream hover:text-gold text-xl transition" />
                </a>
                <a href="https://www.linkedin.com/company/aregash-ethiopian-restaurant/" target="_blank" rel="noopener noreferrer">
                  <FaLinkedinIn className="text-cream hover:text-gold text-xl transition" />
                </a>
                <a href="https://www.tiktok.com/@aregashethio?_t=ZN-8vzfVAmQ77O&_r=1" target="_blank" rel="noopener noreferrer">
                  <FaTiktok className="text-cream hover:text-gold text-xl transition" />
                </a>
              </div>
            </div>

            {/* Map */}
            <div className="rounded-2xl overflow-hidden shadow-lg ring-1 ring-gold/30">
              <iframe
                title="Aregash Ethiopian Restaurant Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2460.6807866722593!2d4.3085884766272295!3d52.07488387195912!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c5b735e1e7f4a3%3A0xaeb99b96b9f74a3d!2sAmsterdamse%20Veerkade%208%2C%202512%20AJ%20Den%20Haag%2C%20Netherlands!5e0!3m2!1sen!2snl!4v1714338234561!5m2!1sen!2snl"
                width="100%"
                height="250"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

          </div>

          {/* Bottom Bar */}
          <div className="mt-10 border-t border-cream/20 pt-6 text-center text-sm text-cream/60">
            &copy; 2025 Aregash Ethiopisch Restaurant. All rights reserved.
          </div>
        </footer>
      </section>

      {/* Flag accent stripe */}
      <div className="flex h-1.5 w-full">
        <div className="flex-1 bg-flag-green" />
        <div className="flex-1 bg-flag-yellow" />
        <div className="flex-1 bg-flag-red" />
      </div>

      {/* Floating reserve button, always reachable while scrolling */}
      {!reservationOpen && (
        <button
          onClick={() => setReservationOpen(true)}
          className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-terracotta hover:bg-terracotta-dark text-cream pl-4 pr-5 py-3 rounded-full shadow-xl ring-1 ring-gold/40 hover:-translate-y-0.5 transition"
        >
          <FaCalendarAlt />
          <span className="font-medium hidden sm:inline">Reserve a Table</span>
          <span className="font-medium sm:hidden">Reserve</span>
        </button>
      )}

    </div>
  );
}

export default App;
